import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from "@angular/core";
import { ResponseType } from "src/utils/enums";

@Component({
  selector: "app-star-rating",
  templateUrl: "./star-rating.component.html",
  styleUrls: ["./star-rating.component.scss"],
  standalone: false
})
export class StarRatingComponent implements OnChanges, OnInit, OnDestroy {
  @Input() questionDetails: any;
  @Input() surveyData: any
  @Output() answerSelectedEvent = new EventEmitter<any>();

  defaultMaskPath = "assets/images/fullface.jpg";
  maskPath: string;
  selectedStars: number = 0;
  isMouseover = true;
  selectedValue: number;
  starIcon = 'star_outline';
  selectedColour = 'grey';

  constructor() {
    console.log("Star rating component loaded.");
  }

  ngOnInit(): void {
    if (this.surveyData.maskUrl === null) {
      this.maskPath = this.defaultMaskPath;
    }
    else {
      this.maskPath = this.surveyData.maskUrl;
    }
    if (this.questionDetails.hasOwnProperty("SelectedAnswer")){
      this.selectedStars =this.questionDetails.SelectedAnswer.AnswerId;
    }
  }

  ngOnChanges(): void {
    if (this.questionDetails.hasOwnProperty("SelectedAnswer")) {
      this.selectedStars = this.questionDetails.SelectedAnswer.Index;
    }
    else {
      this.selectedStars = 0;
    }
  }

  answerSelected(selectedStar: any, rating: number): void {
    this.selectedStars = rating;
    this.answerSelectedEvent.emit(selectedStar);
  }
  ngOnDestroy(): void {

  }

  showIcon(i: number) {
    const star = <HTMLElement> document.getElementsByClassName('star-icon')[i];
    if(i < this.selectedStars) {
      star.style.color = '#ffd700';
      return 'star';
    }
    else {
      star.style.color = 'grey';
      return 'star_outline';
    }
   }
}

